import { type FC } from "react";

import { AskChip } from "@styled/ask_chip";

// Draft all and Items to check, right over the message box. Both always ask
// the assistant; what's counted shows from the Sections count, free. Draft all
// is off with no section the assistant drafts.
export const DraftingChips: FC<{
  disabled: boolean;
  draftable: boolean;
  onAsk(question: string): void;
}> = ({ disabled, draftable, onAsk }) => (
  <>
    <AskChip
      disabled={disabled || !draftable}
      note={draftable ? undefined : "No sections to draft yet"}
      onClick={() => onAsk("Draft all sections")}
    >
      Draft all
    </AskChip>
    <AskChip disabled={disabled} onClick={() => onAsk("Items to check")}>
      Items to check
    </AskChip>
  </>
);
